import { createAction } from 'redux-actions';
import { CUSTOMER_TYPE_ALLOW } from '../config/const';
import { SET_DELIVERY_OPTIONS } from '../actions/types';

const config = { configFetched: false, categories: [], maintenance: false };

const SET_MAINTENANCE = 'SET_MAINTENANCE';
export const SET_SHIPPING_OPTIONS = 'SET_SHIPPING_OPTIONS';
export const SET_CATEGORIES = 'SET_CATEGORIES';

export const setMaintenance = createAction(SET_MAINTENANCE);

const configReducer = (state = config, action) => {
  switch (action.type) {
    case 'SET_CONFIG': {
      state = { ...state, ...action.payload };
      break;
    }
    case SET_MAINTENANCE: {
      state = { ...state, maintenance: action.payload };
      break;
    }
    case SET_SHIPPING_OPTIONS: {
      const {isPickup, isDelivery} = action.payload;

      return {
        ...state,
        ...{ ECOMMERCE_TYPE_INSTORE: isPickup,
          ECOMMERCE_TYPE_DELIVERY: isDelivery,
        },
      };
    }
    case SET_DELIVERY_OPTIONS: {
      const { radius, allowedZip, forbiddenZip } = action.options;

      return {
        ...state,
        ECOMMERCE_ADDRESS_RADIUS: radius,
        ALLOWED_ZIP_CODES: allowedZip,
        FORBIDDEN_ZIP_CODES: forbiddenZip
      };
    }
    case SET_CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    default: {
      return state;
    }
  }
  return state;
};

export const getConfigValue = (configName, state) => {
  if (state.config[configName]) {
    return state.config[configName];
  }
  return undefined;
};

export const toBool = (value, defaultValue) => {
  let stringValue = String(value).toLowerCase();

  if (!stringValue) {
    stringValue = defaultValue;
  }

  return (stringValue === '1' || stringValue === 'true');
}

export const adultSignupsAllowed = (state) => {
  if (state.config[CUSTOMER_TYPE_ALLOW]) {
    return state.config[CUSTOMER_TYPE_ALLOW] === 'ALL' || state.config[CUSTOMER_TYPE_ALLOW] === 'ADULT';
  }
  return false;
};

export const getCategoryNames = (state) => {
  if (state.config.categories) {
    return state.config.categories.map(item => item.name);
  }
  return [];
};

export default configReducer;



// WEBPACK FOOTER //
// ./src/reducers/configReducer.js